// extracted by mini-css-extract-plugin
module.exports = {"root":"ValidateInfo_root__2uC1O","text":"ValidateInfo_text__A9nsa","icon":"ValidateInfo_icon__lVvRM","valid":"ValidateInfo_valid__3eETY"};